import React, {Component} from "react"
import PropTypes from "prop-types"

import notify from "@irati/utils/notify/index"
import getMessage from "@irati/utils/lang/helpers/getMessage/index"
import {injectIntl} from "@irati/utils/lang/index"
import {DISABLED as SCHEDULE_STATUS_DISABLED} from "@irati/insights/constants/schedule"
import {STATUS_CLOSED as SURVEY_STATUS_CLOSED} from "@irati/insights/constants/survey"
import getId from "@irati/utils/id"

import Modal from "../../../../ui/Modal/Modal"
import SoftStop from "./SoftStop"
import {hasActiveSurvey} from "../../../../helpers/schedule"
import {validateEtag} from "../../../../helpers/etag/validateEtag"
import {updateSchedule, updateScheduleWithSurvey} from "../../../../graph/schedule"
import StopOptions from "./StopOptions"

export const SOFT_STOP_VALUE = "soft"
export const HARD_STOP_VALUE = "hard"

class Stop extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: false,
      loading: false,
      selectedStopType: SOFT_STOP_VALUE
    }
  }

  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    schedule: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }

  toolTipOptions = [
    {
      label: this.props.formatMessage({id: "insights.homepage.actions.stop.softLabel"}),
      value: SOFT_STOP_VALUE,
      tooltip: this.props.formatMessage({id: "insights.homepage.actions.stop.softTooltip"})
    },
    {
      label: this.props.formatMessage({id: "insights.homepage.actions.stop.hardLabel"}),
      value: HARD_STOP_VALUE,
      tooltip: this.props.formatMessage({id: "insights.homepage.actions.stop.hardTooltip"})
    }
  ]

  handleAction = () => {
    this.openModal()
  }

  openModal = () => {
    this.setState({show: true})
  }

  closeModal = () => {
    this.setState({show: false})
  }

  handleConfirm = () => {
    this.setState({loading: true})
    const update = this.state.selectedStopType === SOFT_STOP_VALUE ? this.handleSoftStop : this.handleHardStop

    update()
      .then(() => {
        this.setState({loading: false, show: false})
        this.props.onChange()
        notify.success({message: getMessage(this, "insights.actions.stop.notificationSuccess"), position: "top-right"})
      })
      .catch((error) => {
        this.setState({loading: false})
        notify.error({message: getMessage(this, error.contentKey), position: "top-right"})
      })
  }

  handleSoftStop = () => {
    const {id, tenant, Etag} = this.props.schedule
    const schedule = {id, tenant, status: SCHEDULE_STATUS_DISABLED, Etag}
    return updateSchedule({schedule})
  }

  handleHardStop = () => {
    const {id, tenant, latestSurvey} = this.props.schedule
    const schedule = {id, tenant, status: SCHEDULE_STATUS_DISABLED, Etag: validateEtag(this.props.schedule)}
    const survey = {id: latestSurvey.id, tenant, status: SURVEY_STATUS_CLOSED, Etag: validateEtag(latestSurvey)}
    return updateScheduleWithSurvey({schedule, survey})
  }

  handleOptionChange = (selectedStopType) => {
    this.setState({selectedStopType})
  }

  render() {
    const {show, loading, selectedStopType} = this.state
    const {schedule} = this.props
    const showStopOptions = hasActiveSurvey(schedule)
    const idNamespace = getId("Stop", this.props)

    return (
      <Modal
        primary={{
          text: getMessage(this, "insights.homepage.actions.stop.label"),
          onClick: this.handleConfirm
        }}
        secondary={{
          text: getMessage(this, "insights.homepage.actions.closeLabel"),
          onClick: this.closeModal
        }}
        show={show}
        loading={loading}
        handleClose={this.closeModal}
        title={getMessage(this, "insights.homepage.actions.stop.label")}>
        {showStopOptions ? (
          <StopOptions
            id={idNamespace}
            options={this.toolTipOptions}
            onChange={this.handleOptionChange}
            selectedStopType={selectedStopType} />
        ) : (
          <SoftStop />
        )}
      </Modal>
    )
  }
}

export default injectIntl(Stop, {withRef: true})
